<template>
    <div class="gallery-item">
        <div class="gallery-item-inner" @click="setImage(data,data.pos)">
            <router-link 
              :to="`/detail/${data.name}`"
              @click="setImage(data)">
                <div class="image"
                :style="{ backgroundImage: `url('${data.image}')` }"
                style=" background-position: 100% 80%; background-size: cover;">
                    <!-- hidden image for seo and screenreaders etc -->
                    <img class="hidden" :src="data.image"  :alt=" 'American Documents image of ' + data.name + ' ' + data.document_number">
                </div>
                <!-- I believe I did this for accessibility  -->
                <span class="not-visible">{{data.name}}</span>
            </router-link>
            <div class="content">
                <h5 class="image-title mt3 regular">{{ data.name }}</h5>
                <span class="document-number heavy">{{ data.document_number }}</span>
            </div>
        </div>
    </div>
</template>

<script>

import Router from 'vue-router'


import {store} from '../store';

export default {
  name: 'GalleryItem',
  props: ['data','isDownloadable','position'],
  methods: {
    setImage(obj,pos) {
      this.$store.dispatch('updateSelectedImage',[obj,pos]);
    }
  },
  mounted() {
      window.dispatchEvent(new Event('lazy-load'));
  }
}
</script>

<style>
.gallery-item {
  float: left;
  width: 100%;
  padding: 20px;
  text-align: center;
}
.gallery-item-inner {
  background: white;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.3);
  transition: all 150ms ease-out;
}
.gallery-item-inner:hover {
  box-shadow: 0px 16px 43px -16px rgba(0, 0, 0, 0.3);
  transition: all 150ms ease-out;
}
.gallery-item .image {
  width: 100%;
  height: 200px;
  transition: all 300ms ease-out;
}
.gallery-item .content {
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 40px;
}

.image:hover {
    background-position: 100% 100% !important;
    transition: all 300ms ease-out;
}

@media screen and (min-width: 400px) {
  .gallery-item {
    width: 50%;
  }
}
@media screen and (min-width: 678px) {
  .gallery-item {
    width: 33%;
  }
}

.image-title,
.document-number {
  font-size: 13px;
  margin-bottom: 5px;
}

.document-number { font-family: 'Gotham Narrow Bold'; }

.not-visible {display: block;opacity: 0; height: 0;}
</style>



// WEBPACK FOOTER //
// src/components/GalleryItem.vue